function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default ({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M12 0C5.383 0 0 5.383 0 12s5.383 12 12 12 12-5.383 12-12S18.617 0 12 0zm0 22c-2.5 0-4.783-.929-6.538-2.451.008-.013.019-.024.026-.037 1.652-2.768.613-4.459-.154-5.221a7.115 7.115 0 00-.671-.568c-.622-.483-1.034-.802-1.034-1.723 0-.434.242-.604 1.437-1.012.822-.281 1.753-.599 2.354-1.376 1.395-1.804-.139-4.586-.461-5.126a9.065 9.065 0 00-.53-.786 9.945 9.945 0 015.225-1.683c.312.529.827.975 1.333 1.41.432.372 1.118.528 1.471.968.202.252.104.738.111 1.056.014.631.396 1.546 1.684 1.546.057 0 .116-.002.177-.006.498-.035 2.052-.391 3.614-.907A9.934 9.934 0 0122 12c0 5.514-4.486 10-10 10z",
  fill: "#5B6073"
}), /*#__PURE__*/React.createElement("path", {
  d: "M15.514 8.903c-1.576 0-3.185.75-4.003 1.863-.549.748-.709 1.613-.451 2.436.515 1.642.565 2.61.243 3.695-.286.964-.314 2.362 1.319 3.028.308.126.646.19 1.002.19 1.214 0 2.651-.75 3.944-2.062 1.554-1.575 2.468-3.505 2.446-5.165-.03-2.234-2.007-3.985-4.5-3.985z",
  fill: "#5B6073"
}));